import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import HeaderFour from '../header/HeaderFour';
import BreadcrumbSd from '../inner/breadcrumb/BreadcrumbSd';
import Footer from '../elements/Footer';
import Help from './Help';
import HeaderNew from '../header/HeaderNew';

function ServiceDetails() {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get('id');

    const [service, setService] = useState(null);

    useEffect(() => {
        axios.get(`https://solanthegroup.com/admin/api/services/${id}`)
            .then(response => {
                setService(response.data[0]); // Assuming you get the service data in an array
            })
            .catch(error => {
                console.error("Error fetching service details:", error);
            });
    }, [id]);

    if (!service) {
        return <div className="loading"></div>;
    }

    return (
        <div className='service-details'>
            <div className="">
                <HeaderNew/>
                <main>
                    {/* <div className="breadcrumb-area bg_image tmp-section-gap"
                        style={{ backgroundImage: `url(assets/images/breadcrumb/service.webp)` }}>
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-12">
                                    <div className="breadcrumb-inner text-center">
                                        <h1 className="title split-collab">Service Details</h1>
                                        <ul className="page-list">
                                            <li className="tmp-breadcrumb-item">
                                                <a href="/">Home</a>
                                            </li>
                                            <li className="icon">
                                                <i className="fa-solid fa-angle-right" />
                                            </li>
                                            <li className="tmp-breadcrumb-item active">Service Details</li>
                                        </ul>
                                        <div className="circle-1" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    {/* tmp service section */}
                    <div className="tmp-service-section tmp-section-gap">
                        <div className="container">
                            <div className="row">
                                <div className="col-lg-8">
                                    <div className="tmp-large-service-detials">
                                        <img
                                            className="w-100"
                                            src={`https://solanthegroup.com/admin/${service.banner}`}
                                            alt={service.title}
                                        />
                                    </div>
                                    {/* single service details component */}
                                    <div className="single-service-details-component mt--40">
                                        <h2 className="title split-collab">
                                            {service.title}
                                        </h2>
                                        <p className="disc mb--20">
                                            <span dangerouslySetInnerHTML={{ __html: service.description }}></span>
                                        </p>
                                        <div className="row">
                                            <div className="col-lg-6 col-md-6">
                                                {/* chck-area-wrapper */}
                                                <div className="check-service-wrapper">
                                                    {service.single_check_one && (
                                                        <div className="single-check">
                                                            <i className="fa-light fa-circle-check" />
                                                            <p>{service.single_check_one}</p>
                                                        </div>
                                                    )}
                                                    {service.single_check_two && (
                                                        <div className="single-check">
                                                            <i className="fa-light fa-circle-check" />
                                                            <p>{service.single_check_two}</p>
                                                        </div>
                                                    )}
                                                </div>
                                                {/* chck-area-wrapper end */}
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                {/* chck-area-wrapper */}
                                                <div className="check-service-wrapper">
                                                    {service.single_check_three && (
                                                        <div className="single-check">
                                                            <i className="fa-light fa-circle-check" />
                                                            <p>{service.single_check_three}</p>
                                                        </div>
                                                    )}
                                                    {service.single_check_four && (
                                                        <div className="single-check">
                                                            <i className="fa-light fa-circle-check" />
                                                            <p>{service.single_check_four}</p>
                                                        </div>
                                                    )}
                                                </div>
                                                {/* chck-area-wrapper end */}
                                            </div>
                                        </div>
                                    </div>
                                    {/* single service details component end */}
                                    <div className="row g-5 mt--10">
                                        <div className="col-lg-6 col-md-6">
                                            {/* single service large-details */}
                                            <div className="single-service-details">
                                                <div className="icon">
                                                    <img
                                                        src={`https://solanthegroup.com/admin/${service.single_service_first_container_logo}`}
                                                        alt={service.single_service_first_container_title}
                                                    />
                                                </div>
                                                <div className="information">
                                                    <h6 className="title">{service.single_service_first_container_title}</h6>
                                                    <p className="disc">
                                                        <span dangerouslySetInnerHTML={{ __html: service.single_service_first_container_description }}></span>
                                                    </p>
                                                </div>
                                            </div>
                                            {/* single service large-details end */}
                                        </div>
                                        <div className="col-lg-6 col-md-6">
                                            {/* single service large-details */}
                                            <div className="single-service-details">
                                                <div className="icon">
                                                    <img
                                                        src={`https://solanthegroup.com/admin/${service.single_service_second_container_logo}`}
                                                        alt={service.single_service_second_container_title}
                                                    />
                                                </div>
                                                <div className="information">
                                                    <h6 className="title">{service.single_service_second_container_title}</h6>
                                                    <p className="disc">
                                                        <span dangerouslySetInnerHTML={{ __html: service.single_service_second_container_description }}></span>
                                                    </p>
                                                </div>
                                            </div>
                                            {/* single service large-details end */}
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-4 pl--50 pl_md--15 pl_sm--10 mt_md--50 mt_sm--50">
                                    <div className="side-bar-details-page">
                                        <Help />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    {/* tmp service section end */}
                    <Footer />
                </main>
            </div>

            <style>{`
            .single-service-details{
            height:100%;
            }
            .single-service-details.disc{
            font-size:17px
            }
            `}</style>
        </div>
    );
}

export default ServiceDetails;
